const users = {
  module: "Users",
  title: "Students/Users",
  new_user: "New User",
  edit_user: "{name}",
  edit_account: "Edit Account: {name}",
  edit_role: "Edit Role: {name}",
  view_user: "View User: {name}",
  person_title: "User Details",
  list_title: "List of Users",
  list_subtitle: "Manage users",
  details_title: "User Details",
  account_title: "Account Details",
  address_title: "Address Details",
  organisation_title: "Organisation Details",
  account_setting: "Edit Account Details",
  view_details: "View Details",
  id: "ID",
  pid: "PID",
  identification: "Identification",
  unique_id: "ID",
  first_name: "First Name",
  last_name: "Last Name",
  middle_name: "Middle Name",
  mobile: "Mobile Phone",
  status: "Status",
  logs: "Logs",
  email: "Email Address",
  password: "Password",
  company_name: "Company Name",
  company_vat: "VAT",
  search_organisations: "Search for Organisations...",
  merge_students: "Merge Students",
  merge_success: "Students successfully merged.",
  merge_failed: "Failed to merged students.",
  profile: "Profile",
  changepass: "Change Password",
  sync_ok: "Sync complete",
  verify: "Verify",
  image_not_verified: "Image not verified",
  verify_image_confirmation: "Are you sure you want to verify this image?",
  verify_success: "Image successfully verified.",
  documents: "Documents",
  add_documents: "Add Document",
  documents_notice:
    "Documents uploaded here are visible for course instructors. To add previously received expertise upload your documents here and contact learning company/school for authorisation",
  upload_documents: "Upload Documents",
  enter_code: "Enter Code",
  enter_code_email: "Confirmation code is sent to {email}",
  email_verification_send_failed:
    "Email not sent. Please contact administrator.",
  email_verification_incorrect_code: "Incorrect or expired code.",
  enter_code_sms: "Confirmation code is sent to {mobile}",
  sms_otp_send_failed: "SMS not sent. Please contact administrator.",
  sms_otp_incorrect_code: "Incorrect or expired code.",
  access_granted: "Access Granted",
  companies_employed: "Companies Employed",
  company_vat_not_exist:
    "Company with entered VAT number is not registered in certreg",
  company_already_has_access:
    "Company with entered VAT number already have accesss to this user",
  new_company_access: "Add new company access",
  edit_company_access: "Edit company access",
  cancel_enrolment: "Cancel Enrolment",
  cancel_enrolment_confirmation:
    "Are you sure you want to cancel your enrolment?",
  cancel_enrolment_success: "Enrolment successfully cancelled.",
  cancel_enrolment_failed: "Failed to cancel your enrolment.",
  qr_show: "Show",
  qr_control: "Control",
  qr_scan_title: "Scan QRCode",
  qr_rescan: "Rescan QRCode",
  qr_waiting_user_confirm:
    "Waiting for user to accept the request to view the student's data",
  qr_confirmation_view_data:
    "Would you like to temporary allow {name} to see your data?",
  qr_user_denied: "User has denied access",
  qr_use_access_expired: "Access expired,",
  age_below_18:
    "Personer under 18 år kan ikke utføre arbeid som medfører fare for liv eller helse. Forskrift om administrative ordninger §12-6 Selv om personen har fått og bestått opplæring som beskrevet under, kan ikke personer under 18 år, settes til selvstendig arbeid som kan medføre fare for live eller helse. Denne type arbeid kan bare gjennomføres som del av yrkesrettet opplærings, iht. unntak fra arbeidsforbud, Forskrift om organisering og ledelse §12-7",
  show_deleted_documents: "Show deleted documents",
  show_documents: "Show documents",
  deleted_documents: "(Deleted documents)",
  find_duplicates: "Find duplicates",
  merge_and_next: "Merge and go to next",
  skip_and_next: "Skip and go to next",
  duplicate_of: "Duplicate {counter} of {count}",
  found_potentials: "Found {count} potential duplicates",
  equal_identification_number: "Equal identification number",
  equal_mobile_number: "Equal mobile number",
  equal_email: "Equal email",
  equal_first_name: "Equal first name",
  equal_last_name: "Equal last name",
  equal_birthday: "Equal birthday",
  no_duplicate_found: "No duplicate found",
  tenant: "Tenant",
  subdomain: "Subdomain",
  deparment: "Department",
  employee_number: "Employee number",
  edit: {
    password_no_match: "Password does not match",
    personal_info: "Personal Information",
    old_pass: "Current Password",
    new_pass: "New Password",
    confirm_pass: "Confirm Password",
    password_success: "Password Successfully Updated.",
    password_error:
      "Changing of password not success. The entered old password doesn't match in our records!",
  },
}
export default users
